import BaseAction from "base/base.action";
import { GoogleAdsType } from "domain/types/googleAds.type";
import { GadsFilterParams } from "model/googleAds/googleAds.request";
import { HourlyCoCResponse, HighestCostKeywordsResponse, LowestConvKeywordsResponse } from "model/googleAds/googleAds.response";
import { CampaignOption, AdGroupOption, GadsSyncStatus } from "model/googleAds/googleAds.model";

export const setGadsFilters = (filters: GadsFilterParams) =>
  BaseAction(GoogleAdsType.SET_FILTERS, { filters });

// Hourly CoC
export const fetchHourlyCoCRequest = (params: GadsFilterParams) =>
  BaseAction(GoogleAdsType.FETCH_HOURLY_COC_REQUEST, { params });
export const fetchHourlyCoCSuccess = (data: HourlyCoCResponse) =>
  BaseAction(GoogleAdsType.FETCH_HOURLY_COC_SUCCESS, { data });
export const fetchHourlyCoCFailure = (error: string) =>
  BaseAction(GoogleAdsType.FETCH_HOURLY_COC_FAILURE, { error });

// Highest Cost Keywords
export const fetchHighestCostKwRequest = (params: GadsFilterParams) =>
  BaseAction(GoogleAdsType.FETCH_HIGHEST_COST_KW_REQUEST, { params });
export const fetchHighestCostKwSuccess = (data: HighestCostKeywordsResponse) =>
  BaseAction(GoogleAdsType.FETCH_HIGHEST_COST_KW_SUCCESS, { data });
export const fetchHighestCostKwFailure = (error: string) =>
  BaseAction(GoogleAdsType.FETCH_HIGHEST_COST_KW_FAILURE, { error });

// Lowest Conversion Keywords
export const fetchLowestConvKwRequest = (params: GadsFilterParams) =>
  BaseAction(GoogleAdsType.FETCH_LOWEST_CONV_KW_REQUEST, { params });
export const fetchLowestConvKwSuccess = (data: LowestConvKeywordsResponse) =>
  BaseAction(GoogleAdsType.FETCH_LOWEST_CONV_KW_SUCCESS, { data });
export const fetchLowestConvKwFailure = (error: string) =>
  BaseAction(GoogleAdsType.FETCH_LOWEST_CONV_KW_FAILURE, { error });

// Campaigns
export const fetchCampaignsRequest = () =>
  BaseAction(GoogleAdsType.FETCH_CAMPAIGNS_REQUEST, {});
export const fetchCampaignsSuccess = (campaigns: CampaignOption[]) =>
  BaseAction(GoogleAdsType.FETCH_CAMPAIGNS_SUCCESS, { campaigns });
export const fetchCampaignsFailure = (error: string) =>
  BaseAction(GoogleAdsType.FETCH_CAMPAIGNS_FAILURE, { error });

// Ad Groups
export const fetchAdGroupsRequest = (campaignId: string) =>
  BaseAction(GoogleAdsType.FETCH_AD_GROUPS_REQUEST, { campaignId });
export const fetchAdGroupsSuccess = (adGroups: AdGroupOption[]) =>
  BaseAction(GoogleAdsType.FETCH_AD_GROUPS_SUCCESS, { adGroups });
export const fetchAdGroupsFailure = (error: string) =>
  BaseAction(GoogleAdsType.FETCH_AD_GROUPS_FAILURE, { error });

// Sync Status
export const fetchSyncStatusRequest = () =>
  BaseAction(GoogleAdsType.FETCH_SYNC_STATUS_REQUEST, {});
export const fetchSyncStatusSuccess = (status: GadsSyncStatus) =>
  BaseAction(GoogleAdsType.FETCH_SYNC_STATUS_SUCCESS, { status });
export const fetchSyncStatusFailure = (error: string) =>
  BaseAction(GoogleAdsType.FETCH_SYNC_STATUS_FAILURE, { error });
